<template>
	<div class="home">
		<ThumbnailImage :image="gardenImage" />
	</div>
</template>

<script>
import store from "@/store";
import ThumbnailImage from "@/components/ThumbnailImage";
import gardenImage from "@/assets/img/garden-overview.jpg";

export default {
	name: "home",
	components: {
		ThumbnailImage
	},
	data() {
		return {
			gardenImage
		};
	},
	mounted() {
		const content = store.state.content[this.$attrs.id];
		store.changeNavigationData(content.title, content.text);
	}
};
</script>
